/**
 * gtr所有子系统默认配置
 * 作用：动态获取子系统配置失败后，默认的兜底配置
 */
export const microApps = [
  {
    name: 'b_audit-mgr_i18n',
    appLocation: ['/mcenter'],
  },
  {
    name: 'b_console_i18n',
    appLocation: ['/authmanage'],
  },
  {
    name: 'b_sales-task_i18n',
    appLocation: ['/operateTask', '/task'],
  },
  {
    name: 'b_crm_i18n',
    appLocation: ['/bizopp', '/leads', '/farming', '/stores', '/process', '/visit-next', '/addShop', '/party', '/area', '/commision', '/photo', '/brand', /^\/shop\/(?!activity)/, '/contract-change'],
  },
  {
    name: 'b_delivery-op_i18n',
    appLocation: ['/operations/reward', '/ridergrade', /^\/rider$/, /^\/rider\/(?!valution)/, '/supplier', '/recommend'],
  },
  {
    name: 'd_label-center_i18n',
    appLocation: ['/tagcenter'],
  },
  {
    name: 'b_supply_i18n',
    appLocation: ['/supply', '/manual', '/radius', '/bcConfig'],
  },
  {
    name: 'b_finance_i18n',
    appLocation: ['/finance', '/invoice', '/riderRfc', '/bank-manage', '/expense-manage'],
  },
  {
    name: 'b_cfg-mgr_i18n',
    appLocation: ['/launch-initialization', '/consumer', '/rider/valution', '/businessDistribution'],
  },
  {
    name: 'b_trans-mgr_i18n',
    appLocation: ['/order', '/trip', '/user', '/evaluation'],
  },
  {
    name: 'b_usr-mkt_i18n',
    appLocation: [/^\/operations\/(?!reward)/],
    entry: '/operations/landingPageCombo',
  },
  {
    name: 'b_merchant-op_i18n',
    appLocation: ['/platform-item-manage', '/brand-item-manage', '/shop/activity', '/dish', '/poseidon', '/flowcontrol', '/guidance', '/service-control', '/p-cancel', '/scenter', '/shopV2', '/new-store', '/picture-quality'],
  },
  {
    name: 'b_tianji_i18n',
    appLocation: ['/tianji'],
  },
  {
    name: 'b_material_i18n',
    appLocation: ['/inventory'],
  },
];
// 未接入gtr微前端的子系统
export const otherApps = [
  // 投放平台
  {
    name: 'b_feature_i18n',
    appLocation: ['/starlink'],
  },
  // 客服平台项目，主要针对pad，移动端的，暂不需接入 https://pre-gattaran.didi-food.com/customerService/entrega/order/detail?orderId=5764618002251186963&cityId=52210400
  {
    name: 'b_customer-service_i18n',
    appLocation: ['/customerService'],
  },
];
export const prefetchNum = 3;

export const ignoreScript = ['watermark.xiaojukeji.com', 'maps.googleapis', 'map_webapp_ibt/mapsdk'];

export const jumpErrorPageCode = ['LOADING_SOURCE_CODE', 'SKIP_BECAUSE_BROKEN'];
